"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SelectDropdown_component_exports = {};
__export(SelectDropdown_component_exports, {
  SelectDropdown: () => SelectDropdown
});
module.exports = __toCommonJS(SelectDropdown_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react2 = require("@floating-ui/react");
var import_clsx = __toESM(require("clsx"));
const SelectDropdown = ({
  context,
  isOpen,
  onKeyDown,
  refs,
  modifiedFloatingStyles,
  singleSelect,
  simpleSelect,
  getFloatingProps,
  elementsRef,
  labelsRef,
  children,
  onKeyUp,
  customSelect,
  buttonWidth,
  optionsContainerStyle,
  dropdownWidthPercent,
  matchButtonWidth
}) => {
  const dropdownVisibility = isOpen ? "visible" : "hidden";
  const dropdownClass = getDropdownClass(singleSelect, simpleSelect, customSelect);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react2.FloatingFocusManager, { context, modal: false, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    {
      "data-testid": "options__list",
      tabIndex: -1,
      style: __spreadValues({
        visibility: dropdownVisibility,
        position: "absolute"
      }, optionsContainerStyle),
      onKeyDown,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        DropdownContent,
        {
          dropdownClass,
          refs,
          modifiedFloatingStyles,
          getFloatingProps,
          onKeyUp,
          elementsRef,
          labelsRef,
          children,
          buttonWidth,
          singleSelect,
          customSelect,
          simpleSelect,
          dropdownWidthPercent,
          matchButtonWidth
        }
      )
    }
  ) });
};
const getDropdownClass = (singleSelect, simpleSelect, customSelect) => {
  return (0, import_clsx.default)([
    !(singleSelect || simpleSelect || customSelect) && "flex min-w-44 max-w-80 flex-col overflow-x-hidden bg-raised mt-1 border-solid bg-[--color-bg-raised] border-[--color-border-surface-with-contrast] border rounded-s shadow-medium",
    (singleSelect || simpleSelect || customSelect) && "absolute left-0 top-full mt-2xs flex max-h-[268px] flex-col rounded-s bg-[--color-bg-raised] outline-none z-10 shadow-medium"
  ]);
};
const DropdownContent = ({
  dropdownClass,
  refs,
  modifiedFloatingStyles,
  getFloatingProps,
  onKeyUp,
  elementsRef,
  labelsRef,
  children,
  buttonWidth,
  singleSelect,
  customSelect,
  simpleSelect,
  dropdownWidthPercent,
  matchButtonWidth
}) => {
  let calculatedWidth = "240px";
  if (buttonWidth) {
    if (dropdownWidthPercent !== void 0) {
      calculatedWidth = `${buttonWidth * dropdownWidthPercent / 100}px`;
    } else if (matchButtonWidth) {
      calculatedWidth = `${buttonWidth}px`;
    }
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      "aria-expanded": "true",
      "aria-label": "Dropdown options",
      className: dropdownClass,
      ref: refs.setFloating,
      style: __spreadProps(__spreadValues({}, modifiedFloatingStyles), {
        overflowY: "auto",
        width: singleSelect || customSelect || simpleSelect ? calculatedWidth : "auto",
        border: singleSelect || customSelect || simpleSelect ? "1px solid var(--color-border-surface-with-contrast)" : void 0
      })
    }, getFloatingProps()), {
      "data-testid": "select-list-testid",
      onKeyUp,
      role: "listbox",
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react2.FloatingList, { elementsRef, labelsRef, children })
    })
  );
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SelectDropdown
});
//# sourceMappingURL=SelectDropdown.component.js.map